// extracted by mini-css-extract-plugin
export default {"wrapper":"tutorAccruals_wrapper__hmMcQ","payouts":"tutorAccruals_payouts__Jn9Yy"};